import { deserialize, Expose, Serializable, Transform } from '@tokeet-frontend/tv3-platform'
import * as moment from 'moment'

export class Flight extends Serializable<Flight> {
  @Expose({ name: 'flight_num' })
  flightNum: string

  airline: string
  timezone: string
  @Transform((value) => (+value ? +value : moment(value).unix()))
  departure: number
  @Transform((value) => (+value ? +value : moment(value).unix()))
  arrival: number

  static deserialize(data: object): Flight {
    return deserialize(Flight, data)
  }
}
